import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FcanyComponent } from './fcany.component';
import { FcavatarComponent } from './fcavatar.component';
import { FcbacktopComponent } from './fcbacktop.component';
import { FcbuttonComponent } from './fcbutton.component';
import { FccalendarComponent } from './fccalendar.component';
import { FccarouselComponent } from './fccarousel.component';
import { FccheckComponent } from './fccheck.component';
import { FcchosenComponent } from './fcchosen.component';
import { FccomboComponent } from './fccombo.component';
import { FcdateComponent } from './fcdate.component';
import { FcdatetimeComponent } from './fcdatetime.component';
import { FctimeComponent } from './fctime.component';
import { FcdividerComponent } from './fcdivider.component';
import { FcdoubleComponent } from './fcdouble.component';
import { FcfastpositionComponent } from './fcfastposition.component';
import { FciconComponent } from './fcicon.component';
import { FclongComponent } from './fclong.component';
import { FcpopoverComponent } from './fcpopover.component';
import { FcradioComponent } from './fcradio.component';
import { FcrateComponent } from './fcrate.component';
import { FcswitchComponent } from './fcswitch.component';
import { FctextareaComponent } from './fctextarea.component';
import { FctextComponent } from './fctext.component';
import { FctimelineComponent } from './fctimeline.component';
import { FctitleComponent } from './fctitle.component';
import { FctreeComponent } from './fctree.component';
import { FctableComponent } from './fctable.component';
import { FcuploadComponent } from './fcupload.component';
import { FcmanyComponent } from './fcmany.component';
import { FcbadgeComponent } from './fcbadge.component';
import { FctooltipComponent } from './fctooltip.component';
import { FccascaderComponent } from './fccascader.component';
import { FclistComponent } from './fclist.component';
import { FctagComponent } from './fctag.component';
import { FclinkComponent } from './fclink.component';
import { FclineComponent } from './fcline.component';
import { FclabelComponent } from './fclabel.component';
import { FcpaginationComponent } from './fcpagination.component';
import { FctreeselectComponent } from './fctreeselect.component';
import { FcshareModule } from '../fcshare.modal';
@NgModule({
  imports: [
    FcshareModule
  ],
  exports: [
    FcanyComponent,
    FcmanyComponent,
    FcavatarComponent,
    FcbacktopComponent,
    FcbadgeComponent,
    FcbuttonComponent,
    FccalendarComponent,
    FccarouselComponent,
    FccheckComponent,
    FcchosenComponent,
    FccomboComponent,
    FcdateComponent,
    FcdatetimeComponent,
    FctimeComponent,
    FcdividerComponent,
    FcdoubleComponent,
    FcfastpositionComponent,
     /** FceditorComponent,*/
    FciconComponent,
    FclongComponent,
    FcpopoverComponent,
    FcradioComponent,
    FcrateComponent,
    FcswitchComponent,
    FctextareaComponent,
    FctextComponent,
    FctimelineComponent,
    FctitleComponent,
    FctableComponent,
    FctreeComponent,
    FctreeselectComponent,
    FcuploadComponent,
    FctooltipComponent,
    FccascaderComponent,
    FclistComponent,
    FctagComponent,
    FclinkComponent,
    FclineComponent,
    FclabelComponent,
    FcpaginationComponent
  ],
  declarations: [
    FcanyComponent, 
    FcmanyComponent,
    FcavatarComponent,
    FcbacktopComponent,
    FcbadgeComponent,
    FcbuttonComponent,
    FccalendarComponent,
    FccarouselComponent,
    FccheckComponent,
    FcchosenComponent,
    FccomboComponent,
    FcdateComponent,
    FcdatetimeComponent,
    FctimeComponent,
    FcdividerComponent,
    FcdoubleComponent,
    FcfastpositionComponent,
     /** FceditorComponent,*/
    FciconComponent,
    FclongComponent,
    FclistComponent,
    FcpopoverComponent,
    FcradioComponent,
    FcrateComponent,
    FcswitchComponent,
    FctextareaComponent,
    FctextComponent,
    FctimelineComponent,
    FctitleComponent,
    FctableComponent,
    FctreeComponent,
    FctreeselectComponent,
    FcuploadComponent,
    FctooltipComponent,
    FccascaderComponent,
    FctagComponent,
    FclinkComponent,
    FclineComponent,
    FclabelComponent,
    FcpaginationComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class FcbasicModule { }